import type { DataTypes } from 'fitify-ui-landing/src/@types'
import { ELEMENT_IDS } from 'fitify-ui-landing/src/@types/constants'
import { ContentRevealAnimation } from 'fitify-ui-landing/src/components/animations/ContentRevealAnimation'
import Container from 'fitify-ui-landing/src/components/Container/Container'
import Section from 'fitify-ui-landing/src/components/Section/Section'
import { ThemeVariants } from 'fitify-ui-landing/src/theme/index'
import { useTranslation } from 'next-i18next'
import { useTheme } from 'styled-components'

import Feature from './Feature'

const Features = ({ items }: { items: DataTypes.FeatureItem[] }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <Section id={ELEMENT_IDS.features}>
      <ContentRevealAnimation>
        <Container>
          {items.map((item: DataTypes.FeatureItem, index: number) => {
            return (
              <Feature
                key={'feature_' + index}
                title={t(item.title)}
                image={item.image}
                imageSet={item.imageSet}
                content={t(item.content)}
                isOdd={index % 2 === 1}
                imageAssets={item.imageAssets}
                headlineVariant={
                  (theme.variant === ThemeVariants.DIGITAL
                    ? 'dg-feature-title'
                    : 'feature-title') as TextTypesVariants
                }
              />
            )
          })}
        </Container>
      </ContentRevealAnimation>
    </Section>
  )
}

export default Features
